<!-- views/Dashboard.vue -->
<template>
  <div class="dashboard-layout">
    <Header />

    <div class="main-content-wrapper">
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Header from '@/components/nav/Header.vue'
import {mapActions} from "vuex";

export default {
  name: 'Dashboard',
  components: {
    Header
  },
  created() {
    // Check if we have a token but no user data
    if (this.$store.getters.isAuthenticated && !this.$store.getters.currentUser) {
      this.$store.dispatch('checkAuth').then(isValid => {
        if (!isValid) {
          // If auth check fails, force logout
          this.handleForceLogout()
        }
      })
    }
  },
  methods: {
    ...mapActions(['checkAuth']),
    handleForceLogout() {
      // Clear auth state
      this.$store.dispatch('logout')

      // Redirect to login
      window.location.href = '/login'
    }
  }
}
</script>

<style scoped>
.dashboard-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  background: #fafafa;
  width: 100%;
}

.main-content-wrapper {
  flex: 1;
  width: 100%;
  overflow-x: auto; /* This enables horizontal scrolling */
}

.main-content {
  width: 100%;
  box-sizing: border-box;
}
</style>
